import { Tag } from "primereact/tag";
import AppPagination from "../../../components/commons/AppPagination";
import { Constant } from "../../../constants/constant";
import AppDialog from "../../../components/commons/AppDialog";
import Dcs0101Form from "./form/Dcs0101Form";
import { toast, ToastContainer } from "react-toastify";
import { showAndHideSpinner } from "../../../reducers/spinnerSlice";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/hook";
import { Dcs0101Service } from "../../../services/dcs/Dcs0101Service";
import moment from "moment";
import Swal from "sweetalert2";
import { VariablesConstant } from "../../../constants/variables";
import Dcs0101ViewData from "./view-data/Dcs0101ViewData";
import { ComStdService } from "../../../services/common/ComStdService";
import { Dropdown } from "primereact/dropdown";
import ViewConnection from "./view-connection/ViewConnection";
import { useSelector } from "react-redux";
import ViewConnectionStatus from "./components/ViewConnectionStatus";
import ViewDeviceStatus from "./components/ViewDeviceStatus";
import { useAppSelector } from "../../../store/hook";
import FunctionButton from "../../../components/layout/FunctionButton";
import Dcs0301Service from "../../../services/dcs/Dcs0301Service";

export class Dcs0101Search {
  connNm?: any;
  status?: string;
  protocol?: any;
  page: number;
  size: number;
  time?: number;
  constructor(connNm: any, status: any, protocol: any, page: number, size: number, time: any) {
    this.connNm = connNm;
    this.status = status;
    this.protocol = protocol;
    this.page = page;
    this.size = size;
    this.time = time;
  }
}

export default function Dcs0101() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [status, setStatus] = useState<any>([]);
  const [connProtLst, setConnProtLst] = useState<any>([]);
  const [openForm, setOpenForm] = useState(false);
  const [openViewData, setOpenViewData] = useState(false);
  const [data, setData] = useState({});
  const [connectionId, setConnectionId] = useState<any>();
  const [dataMapId, setDataMapId] = useState<any>();
  const [tableNm, setTableNm] = useState<any>();
  const totalPage = useRef(1);
  const [listConnection, setListConnection] = useState<any>([]);
  const [modelSearch, setModelSearch] = useState<Dcs0101Search>(new Dcs0101Search("", "", "", 0, Constant.ROWS_OF_PAGE, 0));
  const [formStatus, setFormStatus] = useState("");
  const lang = useAppSelector((state: any) => state.language.lang);
  const [protocolSlt, setProtocolSlt] = useState<any>();
  const [statusSlt, setStatusSlt] = useState<any>();

  const [viewLstConnection, setViewLstConnection] = useState<any>(true);
  const [viewConnection, setViewConnection] = useState<any>(false);
  const [insertConnection, setInsertConnection] = useState<any>(false);
  const [viewConnectionDetail, setViewConnectionDetail] = useState<any>(false);

  const [connIdSlt, setConnIdSlt] = useState<any>();

  const message = useSelector((state: any) => state.socket.message);

  useEffect(() => {
    if (message) {
      _getList();
    }
  }, [message]);

  useEffect(() => {
    _getList();
  }, [modelSearch.connNm, modelSearch.protocol, modelSearch.size, modelSearch.time, modelSearch.status, modelSearch.page]);

  useEffect(() => {
    getConnProtLst();
    getConnStatusLst();
  }, []);

  const closeForm = (data?: any) => {
    // setOpenForm(false);
    if (insertConnection) {
      setInsertConnection(false);
    }
    if (viewConnectionDetail) {
      setViewConnectionDetail(false);
    }

    setViewLstConnection(true);

    if (data) {
      _getList();
    }
  };

  const closeViewData = (data?: any) => {
    setOpenViewData(false);
  };

  const handleChangeConnName = (event: any) => {
    setModelSearch({
      ...modelSearch,
      connNm: event.target.value,
    });
  };

  const search = () => {
    setModelSearch({
      ...modelSearch,
      page: 0,
      time: new Date().getTime(),
    });
  };

  function _getList() {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .getList(modelSearch)
      .then((res: any) => {
        setListConnection(res.data.responseData.data);
        totalPage.current = res.data.responseData.totalElement;
        dispatch(showAndHideSpinner(false));
      })
      .catch((err: any) => { });
  }

  const getConnProtLst = () => {
    // let req = { upCommCd: Constant.CONNECTION_PROTOCOL_TYPE };
    // ComStdService.getInstance()
    //   .getListTccoStd(req)
    //   .then((res: any) => {
    //     setConnProtLst(res.data.responseData);
    //   })
    //   .catch((err: any) => {});

    Dcs0301Service.getInstance().getList({}).then((res: any) => {
      if (res.data.status) {
        setConnProtLst(res.data.responseData.data)
      }
    })
  };

  const getConnStatusLst = () => {
    let req = { upCommCd: Constant.CONNECTION_STATUS };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setStatus(res.data.responseData);
      })
      .catch((err: any) => { });
  };

  const handleChangeSearchProtocol = (data: any) => {
    setProtocolSlt(data);
    setModelSearch({
      ...modelSearch,
      protocol: data.protNm,
      page: 0,
    });
  };

  const handleChangeSearchStatus = (data: any) => {
    setStatusSlt(data);
    setModelSearch({
      ...modelSearch,
      status: data.commCd,
      page: 0,
    });
  };

  const changePage = (page: number) => {
    setModelSearch({
      ...modelSearch,
      page: page,
    });
  };

  const reset = () => {
    setProtocolSlt({});
    setModelSearch({
      ...new Dcs0101Search("", "", "", 0, Constant.ROWS_OF_PAGE, new Date().getTime()),
    });
  };

  const handleAdd = () => {
    setData({
      isCreate: true,
    });
    setFormStatus("C");
    setOpenForm(true);
    setInsertConnection(true);
    setViewLstConnection(false);
  };

  const viewDetail = (obj: any) => {
    setData({ connId: obj.id });
    setFormStatus("DT");
    setOpenForm(true);
    setViewConnectionDetail(true);
    setViewLstConnection(false);
  };

  const viewData = (obj: any) => {
    setTableNm(obj.tableNm);
    setConnectionId(obj.id);
    setDataMapId(obj.dataMapId);
    setOpenViewData(true);
  };

  const handleViewConnection = (element: any) => {
    setConnIdSlt(element.id);
    setViewConnection(true);
    setViewLstConnection(false);
  };

  const handleBack = () => {
    setViewConnection(false);
    setViewLstConnection(true);
    _getList();
  };

  const handleClone = (obj: any) => {
    setData({
      isClone: true,
      connId: obj.id,
    });
    setOpenForm(true);
    setFormStatus("CL");
  };

  const checkConnectionDevice = (obj: any) => {
    dispatch(showAndHideSpinner(true));
    Dcs0101Service.getInstance()
      .checkConnectionStatus({ connId: obj.id })
      .finally(() => {
        dispatch(showAndHideSpinner(false));
      })
      .then((res: any) => {
        let req = { status: res.data.responseData ? VariablesConstant.DEVICE_CONNECTION_STATUS_CONNECTED : VariablesConstant.DEVICE_CONNECTION_STATUS_NOT_CONNECTED, connId: obj.id };
        Dcs0101Service.getInstance()
          .updateDeviceStatus(req)
          .then((res: any) => {
            _getList();
          })
          .catch(() => { });
      })
      .catch((err: any) => { });
  };

  const handleChangeRowOfPage = (data: any) => {
    setModelSearch({ ...modelSearch, size: data });
  };

  return (
    <>
      <ToastContainer></ToastContainer>
      {viewLstConnection && (
        <>
          {/* <AppDialog
            open={openForm}
            style={{ width: "60vw" }}
            onClose={closeForm}
            title={
              formStatus === "C" ? `${t("dcs0101.title.dialog.addConnection")}` : formStatus === "CL" ? `${t("dcs0101.title.dialog.cloneConnection")}` : `${t("dcs0101.title.dialog.detailConnection")}`
            }
            className="width-dialog">
            <Dcs0101Form onClose={closeForm} data={data} />
          </AppDialog> */}

          <AppDialog open={openViewData} style={{ width: "75vw" }} onClose={closeViewData} title={`${t("dcs0101.title.dialog.viewData")}`} className="width-dialog">
            <Dcs0101ViewData onClose={closeViewData} connectionId={connectionId} dataMapId={dataMapId} tableNm={tableNm}></Dcs0101ViewData>
          </AppDialog>

          <div className="box">
            <div className="search-body">
              <div className="d-flex gap-2 align-items-center">
                <div className="search-el">
                  <label className="search-label"> {t("dcs0101.label.status")}</label>
                  <Dropdown
                    value={statusSlt}
                    onChange={(e) => handleChangeSearchStatus(e.value)}
                    options={status}
                    placeholder="All"
                    optionLabel={Constant.SOUTH_KOREA === lang ? Constant.COMM_NM_KR : Constant.COMM_NM_EN}
                  />
                </div>
                <div className="search-el">
                  <label className="search-label"> {t("dcs0101.label.connectionProtocol")}</label>
                  <Dropdown
                    value={protocolSlt}
                    onChange={(e) => handleChangeSearchProtocol(e.value)}
                    options={connProtLst}
                    placeholder="All"
                    // optionLabel={Constant.SOUTH_KOREA === lang ? Constant.COMM_NM_KR : Constant.COMM_NM_EN}
                    optionLabel="protNm"
                  />
                </div>
                <div className="search-el input-search">
                  <input
                    value={modelSearch.connNm || ""}
                    className={`form-control`}
                    name="connNm"
                    placeholder={`${t("dcs0101.label.connectionNm")}`}
                    onChange={handleChangeConnName}
                    onKeyUp={(e: any) => {
                      if (e.key === "Enter") search();
                    }}
                  />
                </div>

                <button type="button" className="custom-btn gradient" onClick={search}>
                  <i className="pi pi-search me-2"></i> {t("sys0301.label.search")}
                </button>
                <button type="button" className="custom-btn" onClick={reset}>
                  <i className="pi pi-refresh me-2"></i> {t("sys0301.label.reset")}
                </button>
              </div>
            </div>
          </div>

          <div className="box">
            <div className="box-body">
              <div className="d-flex justify-content-between mb-3">
                <div className="box-title">
                  <h3 className="mb-sm-0 mb-0 flex-grow-1">{t("dcs0101.label.table.list")}</h3>
                </div>
                <div className="button-head-body d-flex gap-2">
                  <Dropdown
                    value={modelSearch.size}
                    onChange={(e: any) => handleChangeRowOfPage(e.value)}
                    options={Constant.LST_ROW_OF_PAGE}
                    optionLabel={Constant.SOUTH_KOREA === lang ? Constant.LABEL_KR : Constant.LABEL_EN}
                    style={{ minWidth: "100px" }}
                  />
                  <button type="button" className="custom-btn gradient" onClick={handleAdd}>
                    <i className="pi pi-plus me-2"></i> {t("sample.label.button.add")}
                  </button>
                </div>
              </div>
              <div className="tbl-st scroll-x">
                <table>
                  <thead>
                    <tr className="text-center">
                      <th scope="col">{t("dcs0101.table.header.no")}</th>
                      <th scope="col">{t("dcs0101.table.header.connectionNm")}</th>
                      <th scope="col">{t("dcs0101.table.header.connectionProt")}</th>
                      <th scope="col">{t("dcs0101.table.header.ip")}</th>
                      <th scope="col">{t("dcs0101.table.header.port")}</th>
                      <th scope="col">{t("dcs0101.table.header.createdDt")}</th>
                      <th scope="col">{t("dcs0101.table.header.connectionStatus")}</th>
                      <th scope="col">{t("dcs0101.table.header.connectionTest")}</th>
                      <th scope="col">{t("dcs0101.table.header.viewData")}</th>
                      <th scope="col">{t("dcs0101.table.header.viewDetails")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listConnection.map((element: any, index: number) => (
                      <tr className="text-center" key={index} onDoubleClick={() => handleViewConnection(element)}>
                        <td>{totalPage.current  - (modelSearch.page === 0 ? 0 : modelSearch.page - 1) * Constant.ROWS_OF_PAGE - index}</td>
                        <td className="text-start">{element.connNm}</td>
                        <td>{element.protocol?.protNm} - {element.connProtTp?.ver}</td>
                        <td>{element.ip}</td>
                        <td>{element.port}</td>
                        <td>{moment(element.createdDt).format("MM/DD/YYYY")}</td>
                        <td>
                          <div className="slideToggle-btn-wrap d-flex align-items-center gap-3">
                            {element.connectionStatus.commCd === VariablesConstant.DEVICE_CONNECTION_STATUS_CONNECTED ? (
                              <>
                                <span className="slideToggle-btn mg0">
                                  <input type="checkbox" checked readOnly />
                                  <span className="slider"></span>
                                </span>
                                <span className="txt">{t("dcs0101.table.deviceConnected")}</span>
                              </>
                            ) : (
                              <>
                                <span className="slideToggle-btn mg0">
                                  <input type="checkbox" />
                                  <span className="slider"></span>
                                </span>
                                <span className="txt">{t("dcs0101.table.deviceNotConnected")}</span>
                              </>
                            )}
                          </div>
                        </td>
                        {/* <td>
                          <ViewDeviceStatus data={element}></ViewDeviceStatus>
                        </td> */}
                        <td>
                          <a href="javascript:void(0)" className="n-btn1" onClick={() => checkConnectionDevice(element)}>
                            <i className="xi-renew text-black"></i>
                          </a>
                        </td>
                        <td>
                          <a href="javascript:void(0)" className="n-btn1" onClick={() => viewData(element)}>
                            <i className="xi-list text-black"></i>
                          </a>
                        </td>
                        <td>
                          <a href="javascript:void(0)" className="n-btn1" onClick={() => viewDetail(element)}>
                            <i className="xi-ellipsis-h text-black"></i>
                          </a>
                        </td>
                        {/* <td>
                          <i className="pi pi-eye fs-5" style={{ cursor: "pointer" }} onClick={() => viewDetail(element)}></i>
                          <i className="pi pi-clone ps-3 fs-5" style={{ cursor: "pointer" }} onClick={() => handleClone(element)}></i>
                          <i className="pi pi-database ps-3 fs-5" style={{ cursor: "pointer" }} onClick={() => viewData(element)}></i>
                        </td> */}
                      </tr>
                    ))}
                    {listConnection.length === 0 && (
                      <tr className="text-center">
                        <td colSpan={10}>{t("common.table.noData")}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-center">
                {listConnection.length > 0 && <AppPagination page={modelSearch.page} rows={Constant.ROWS_OF_PAGE} onChange={changePage} count={totalPage.current} />}
              </div>
            </div>
          </div>
          <FunctionButton onAdd={handleAdd} currView={VariablesConstant.VIEW_LST_CONNECTION}></FunctionButton>
        </>
      )}
      {viewConnection && <ViewConnection handleBack={handleBack} connId={connIdSlt} />}
      {insertConnection && <Dcs0101Form onClose={closeForm} data={data} />}
      {viewConnectionDetail && <Dcs0101Form onClose={closeForm} data={data} />}
    </>
  );
}
